export const settingsKeys = {
    all: ['settings'] as const,
    transportationRatePolicy: () => [...settingsKeys.all, 'transportation-rate-policy'] as const,
    paymentTerms: () => [...settingsKeys.all, 'payment-terms'] as const,
    serviceTypes: {
        all: ['settings', 'service-types'] as const,
        active: () => [...settingsKeys.serviceTypes.all, 'active'] as const,
        allList: () => [...settingsKeys.serviceTypes.all, 'all'] as const,
    },
}
